import React from "react";
import {
  Alert, Box, Breadcrumbs, Button, Chip, CircularProgress, Link, Stack, Typography, Paper,
} from "@mui/material";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { DataGrid } from "@mui/x-data-grid";

export default function Step4Review({
  currentParent,
  history,
  onBreadcrumbClick,
  error,
  headerRows,
  rankStats,
  loading,
  reviewCandidates,
  dataGridColumns,
  dataGridStyles,
  onSelectAllHeaders,
  onClearSelection,
  selectionModel,
}) {
  if (!currentParent) return null;

  return (
    <Stack spacing={1} sx={{ flex: 1, minHeight: 0 }}>
      <Typography variant="h6">Step 4: 結果のレビューと登録</Typography>
      <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />}>
        {history.map((node, index) => (
          <Link component="button" variant="body2" key={node.db_id} onClick={() => onBreadcrumbClick?.(node, index)}>
            {node.name}
          </Link>
        ))}
      </Breadcrumbs>
      {error && <Alert severity="error" sx={{ my: 1 }}>{error}</Alert>}
      <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
        <Chip label={`合計 ${headerRows.length}`} />
        {Object.entries(rankStats).map(([rank, count]) => (
          <Chip key={rank} label={`${rank}: ${count}`} size="small" />
        ))}
        <Box flexGrow={1} />
        <Button size="small" variant="outlined" onClick={onSelectAllHeaders} disabled={loading || headerRows.length === 0}>全選択</Button>
        <Button size="small" variant="text" onClick={onClearSelection} disabled={selectionModel.length === 0}>選択解除</Button>
      </Stack>
      <Box sx={{ flex: 1, minHeight: 0, width: '100%', mt: 1 }}>
        {loading ? <CircularProgress /> : (
          <Paper variant="outlined" sx={{ height: '100%', p: 0.5 }}>
            <DataGrid
              density="compact"
              rows={reviewCandidates}
              columns={dataGridColumns}
              getRowId={(r) => r.id}
              getRowHeight={() => 'auto'}
              hideFooter
              sortingOrder={['asc', 'desc', null]}
              sx={{
                minWidth: '100%',
                ...dataGridStyles,
                '& .MuiDataGrid-row': { backgroundColor: '#2f3437' },
                '& .MuiDataGrid-row:hover': { backgroundColor: '#2f3437' },
                '& .group-header-row': {
                  backgroundColor: '#34393d',
                  borderTop: '2px solid #555',
                },
              }}
            />
          </Paper>
        )}
      </Box>
    </Stack>
  );
}
